import axios from "axios";

// Preview/deploy domains change; the ingress always routes /api on whatever domain the app is
// served from. If REACT_APP_BACKEND_URL is a different origin than the page, requests would be
// cross-origin-with-credentials, which the ingress rejects (it forces ACAO: *) - so fall back to
// a same-origin relative base in that case.
const configured = process.env.REACT_APP_BACKEND_URL || "";
let base = configured;
try {
  if (configured && new URL(configured).origin !== window.location.origin) base = "";
} catch {
  base = "";
}

const api = axios.create({
  baseURL: `${base}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
